import React, { useState, useEffect } from "react";

import parse from "html-react-parser";
import chroma from "chroma-js";

import { useTranslation } from "react-i18next";

import "./index.css";

import WidgetContainer from "../Widget-Container";
import LinkConfirmationOverlay from "../Link-Confirmation";

export default function DescriptionContent(props) {
  const {
    t,
    // i18n
  } = useTranslation("translation");

  const [overflowing, setOverflowing] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [linkConfirmationOverlay, setLinkConfirmationOverlay] = useState(false);
  const [externalLink, setExternalLink] = useState("");

  useEffect(() => {
    setExternalLink("");
    setLinkConfirmationOverlay(false);

    if (
      props.sceneData.Scrolly.descriptions[props.descriptionID - 1].type !==
      "widget"
    ) {
      setExpanded(false);
      if (
        props.bp !== "lg" &&
        props.bp !== "xl" &&
        document.getElementById("description-text").offsetHeight >= 200
      ) {
        setOverflowing(true);
      } else {
        setOverflowing(false);
      }
    }

    if (
      props.sceneData.Scrolly.descriptions[props.descriptionID - 1].type !==
      "widget"
    ) {
      props.setScrollActive(true);
    }

    // Acount for custom external link element in description text.
    const elems = document.getElementsByClassName("externalURL");
    if (elems.length > 0) {
      for (let i = 0; i < elems.length; i++) {
        elems[i].addEventListener("click", function () {
          handleExternalLink(elems[i].getAttribute("url"));
        });
        elems[i].addEventListener("keypress", function (e) {
          if (e.key === "Enter") {
            handleExternalLink(elems[i].getAttribute("url"));
          }
        });
      }
    }

    // Account for internal link - append icon
    const links_internal = document.getElementsByClassName("internalURL");
    if (links_internal.length > 0) {
      for (let i = 0; i < links_internal.length; i++) {
        if (!links_internal[i].innerHTML.includes("description-text-icon")) {
          links_internal[i].innerHTML =
            links_internal[i].innerHTML +
            `<svg role="img" class="description-text-icon" aria-label="${t("Opens in a new tab.string")}" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" fill="white"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.875 1C10.3918 1 10 1.26678 10 1.75C10 2.23322 10.3918 2.5 10.875 2.5H14.1989L6.09087 10.608C5.79797 10.9009 5.79797 11.3758 6.09087 11.6687C6.38376 11.9616 6.85863 11.9616 7.15153 11.6687L15.5 3.32021V7.125C15.5 7.60822 15.7668 8 16.25 8C16.7332 8 17 7.60822 17 7.125V1.5C17 1.22386 16.7761 1 16.5 1H10.875ZM9 4.25C9 3.83579 8.66421 3.5 8.25 3.5H2.50001L2.5 15.5H14.5L14.5 9.35C14.5 8.93579 14.1642 8.6 13.75 8.6C13.3358 8.6 13 8.93579 13 9.35V14H4V5H8.25C8.66421 5 9 4.66421 9 4.25Z"/></svg>`;
        }
      }
    }
  }, [props.bp, props.descriptionID]);

  useEffect(() => {
    if (linkConfirmationOverlay) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "scroll";
    }
  }, [linkConfirmationOverlay]);

  useEffect(() => {
    if (
      props.sceneData.Scrolly.descriptions[props.descriptionID - 1].type !==
      "widget"
    ) {
      const descriptionData =
        props.sceneData.Scrolly.descriptions[props.descriptionID - 1];
      const highlightArr = descriptionData.props.highlights;
      for (let i = 0; i < highlightArr.length; i++) {
        if (highlightArr[i].string === "") {
          const elemID = document.getElementById(highlightArr[i].id);

          let minimum = toSeconds(highlightArr[i].range.min);
          let maximum = toSeconds(highlightArr[i].range.max);
          minimum = (minimum / props.totalTime) * 100;
          maximum = (maximum / props.totalTime) * 100;

          if (props.percentage >= minimum && props.percentage <= maximum) {
            const highlightColor = highlightArr[i].color;
            let color = "white";
            let linkColor = ""; // Uses default from class
            if (chroma.contrast(highlightColor, color) < 4.5) {
              // WCAG reccomended minimum contrast ratio (with chroma)
              color = "#111";
              linkColor = "#0063C3";
            }
            elemID.style.backgroundColor = highlightColor;
            elemID.style.color = color;
            elemID.style.borderRadius = "3px";
            elemID.style.outline = `${highlightColor} solid 2px`;

            let elems = elemID.getElementsByClassName("externalURL");
            for (let i = 0; i < elems.length; i++) {
              elems[0].style.color = linkColor;
            }
            elems = elemID.getElementsByClassName("internalURL");
            for (let i = 0; i < elems.length; i++) {
              elems[0].style.color = linkColor;
            }

            elems = elemID.getElementsByClassName("description-text-icon");
            for (let i = 0; i < elems.length; i++) {
              elems[i].style.fill = linkColor;
            }
          } else {
            elemID.style.backgroundColor = "transparent";
            elemID.style.color = "inherit";
            elemID.style.borderRadius = "3px";
            elemID.style.outline = "none";

            let linkElems = elemID.getElementsByClassName("externalURL");
            for (let i = 0; i < linkElems.length; i++) {
              linkElems[i].style.color = ""; // Uses default from class
            }
            linkElems = elemID.getElementsByClassName("internalURL");
            for (let i = 0; i < linkElems.length; i++) {
              linkElems[i].style.color = "";
            }

            linkElems = elemID.getElementsByClassName("description-text-icon");
            for (let i = 0; i < linkElems.length; i++) {
              linkElems[i].style.fill = "";
            }
          }
        }
      }
    }
  }, [props.percentage]);

  const renderBasicDescription = () => {
    return (
      <div
        id="description-content"
        className={`description-content ${props.descriptionID === 1 && props.sceneData.Scrolly.descriptions[0].range.min === "00:00.00" ? "updates" : "updates"}`}
        style={{
          width:
            props.bp !== "lg" && props.bp !== "xl"
              ? "calc(100vw - 86px)"
              : null,
          marginTop: props.bp === "lg" || props.bp === "xl" ? "28px" : null,
          maxHeight:
            props.bp === "lg" || props.bp === "xl" || expanded
              ? "calc(100vh - 100px)"
              : null,
          paddingBottom: expanded ? "0px" : null,
          backgroundColor: expanded ? "#346589" : null,
          overflow:
            props.bp === "lg" || props.bp === "xl" || expanded
              ? "scroll"
              : "hidden",
          border:
            props.bp !== "lg" && props.bp !== "xl" ? "1px solid white" : null,
          fontSize:
            props.bp === "lg" ? null : props.bp === "xl" ? "28px" : "18px",
          position: props.bp !== "lg" && props.bp !== "xl" ? "absolute" : null,
        }}
      >
        <div
          id="description-text"
          className="description-text"
          style={{
            overflow:
              props.bp === "lg" || props.bp === "xl" || expanded
                ? "scroll"
                : null,
          }}
        >
          {!props.debug || !props.preview ? null : (
            <div
              className="description-debug"
              role="button"
              tabIndex="0"
              onClick={() => {
                window.open(
                  props.sceneData.Scrolly.descriptions[props.descriptionID - 1]
                    .recordURL,
                  "_blank"
                );
              }}
              onKeyUp={(e) => {
                if (e.key === "Enter") {
                  window.open(
                    props.sceneData.Scrolly.descriptions[
                      props.descriptionID - 1
                    ].recordURL,
                    "_blank"
                  );
                }
              }}
            >
              {props.sceneData.Scrolly.descriptions[props.descriptionID - 1].id}
            </div>
          )}
          {formattedDescription()}
        </div>
        <div
          id="expand-collapse"
          className="expand-collapse"
          role="button"
          tabIndex="0"
          style={{
            display:
              !overflowing || props.bp === "lg" || props.bp === "xl"
                ? "none"
                : null,
            position: !expanded ? "absolute" : "sticky",
            bottom: !expanded ? "0px" : "0px",
          }}
          onClick={() => {
            document.getElementById("description-content").scrollTop = 0;
            setExpanded(!expanded);
          }}
          onKeyUp={(e) => {
            const keycode = e.keyCode ? e.keyCode : e.which;
            if (keycode === 13) {
              document.getElementById("description-content").scrollTop = 0;
              setExpanded(!expanded);
            }
          }}
        >
          {expanded
            ? t(`descriptionCollapse.string`)
            : t(`descriptionExpand.string`)}
        </div>
      </div>
    );
  };

  const formattedDescription = () => {
    const descriptionData =
      props.sceneData.Scrolly.descriptions[props.descriptionID - 1];

    const highlightArr = descriptionData.props.highlights;

    let description = t(`${descriptionData.props.descriptionTxt}.string`);

    if (highlightArr.length > 0) {
      for (let i = 0; i < highlightArr.length; i++) {
        let minimum = toSeconds(highlightArr[i].range.min);
        let maximum = toSeconds(highlightArr[i].range.max);
        minimum = (minimum / props.totalTime) * 100;
        maximum = (maximum / props.totalTime) * 100;

        const highlightString = t(`${highlightArr[i].string}.string`);
        const highlightColor = highlightArr[i].color;

        if (props.percentage >= minimum && props.percentage <= maximum) {
          if (description.includes(highlightString)) {
            let color = "white";

            if (chroma.contrast(highlightColor, color) < 4.5) {
              // If the dark alternative does not meet the requirement, black (#111) is chosen by default.
              color = "#111";
            }

            const newString = `<b style="background-color: ${highlightColor}; color:${color}; font-weight: inherit; outline: ${highlightColor} solid 2px; border-radius: 5px;">${highlightString}</b>`;

            let occurrence = 1;
            if (
              highlightArr[i].occurrence &&
              highlightArr[i].occurrence !== ""
            ) {
              occurrence = highlightArr[i].occurrence;
            }

            const index = description
              .split(highlightString, occurrence)
              .join(highlightString).length;
            const replaced =
              description.substring(0, index) +
              newString +
              description.substring(index + highlightString.length);

            description = replaced;
          }
        } else {
          if (description !== null && description.includes(highlightString)) {
            description = description.replace(highlightString, highlightString);
          }
        }
      }
    }

    return <p>{parse(description)}</p>;
  };

  const renderWidgetContainer = () => {
    return (
      <WidgetContainer
        sceneData={props.sceneData}
        percentage={props.percentage}
        forceAnimationTo={props.forceAnimationTo}
        forceScroll={props.forceScroll}
        descriptionID={props.descriptionID}
        setDescriptionID={props.setDescriptionID}
        totalTime={props.totalTime}
        bp={props.bp}
        scrollActive={props.scrollActive}
        setScrollActive={props.setScrollActive}
        plotFunctions={props.plotFunctions}
        debug={props.debug}
        preview={props.preview}
      />
    );
  };

  const handleExternalLink = (url) => {
    setExternalLink(url);
    setLinkConfirmationOverlay(true);
  };

  const toSeconds = (timeStamp) => {
    // "00:00.00" (minutes:seconds) to seconds for percentage calculations and comparisons
    const timeArr = timeStamp.split(":");
    const seconds = Number(timeArr[0]) * 60 + Number(timeArr[1]);
    return seconds;
  };

  return (
    <div>
      {props.sceneData.Scrolly.descriptions[props.descriptionID - 1].type ===
        "widget" && props.descriptionID !== "end"
        ? renderWidgetContainer()
        : renderBasicDescription()}
      {linkConfirmationOverlay ? (
        <LinkConfirmationOverlay
          url={externalLink}
          close={() => setLinkConfirmationOverlay(false)}
          bp={props.bp}
        />
      ) : null}
    </div>
  );
}
